import React, {useEffect, useState} from 'react'
import parse from 'html-react-parser'
import SynkinesisQuestionRow from './SynkinesisQuestionRow'
import Form from 'react-bootstrap/Form'

function SynkinesisQuestionGroup(props) {

    const [answers, setAnswers] = useState([])
    const [values, setValues] = useState({})

    // console.log("SynkinesisQuestionGroup props:", props)
    // console.log("props.questions", props.questions)
    // console.log("questions filtered",
    //     props.questions.filter(q => !!q.DictIntakeFormQuestion.display_name_short || !!q.DictIntakeFormQuestion.display_name || !!q.DictIntakeFormQuestion.question_type)
    // )

    useEffect(() => {
            

        // initialize values
        // const vals = props.questions.map(q => {
        //     return { [q.DictIntakeFormQuestion.display_name_short] : 0}
        // })
        if (!!props.values) {
            setValues(props.values)
        } else {
            let vals = {}
            // do not include questions without input elements

            
            props.questions
                .filter(q => !!q.DictIntakeFormQuestion.display_name_short || !!q.DictIntakeFormQuestion.display_name || !!q.DictIntakeFormQuestion.question_type)
                .forEach(q => {
                    vals = {...vals, [q.DictIntakeFormQuestion.display_name_short] : 0}
                })
            // console.log("vals", vals)
            setValues(vals)
        }
        
        // question answers
        // const q_answ = JSON.parse(props.questions[0].DictIntakeFormQuestion.question_option)
        const q_answ = props.questions[0].DictIntakeFormQuestion.mapped_property
        // const q_answ = [props.questions[0].DictIntakeFormQuestion.mapped_property]
        // console.log("**** Synkinesis QuestionGroup **** q_answ", q_answ)
        // question values
        const q_vals = JSON.parse(props.questions[0].DictIntakeFormQuestion.question_option_values)
        // const q_vals = JSON.parse("[0,1,2,3,4,5]")
        // console.log("**** Synkinesis QuestionGroup **** q_vals", q_vals)
        // set answers as array - each element has properties: answer and value
        if (!!q_answ && Array.isArray(q_answ)) {
            const q_answ_val = q_answ.map((a, i) => ({answer: a, value: q_vals[i]}))

        // console.log("**** Synkinesis QuestionGroup **** q_answ_val", q_answ_val)

        
            setAnswers(q_answ_val)
        } else {
            setAnswers([])
        }
        
        // setAnswers(JSON.parse(props.questions[0].question_option))

        // const parse = require('html-react-parser')
        // setGroupHeader1(parse(props.questions[0].group_header1))

    }, [props.group_id, props.errors, props.values])


    // calculate sum
    const calculateSum = (vals, name) => {
        // get names of values to use add
        // console.log("Calculating sum - name, vals", name, vals)
        let sum = 0
        const sumElement = props.questions.find(q => q.DictIntakeFormQuestion.display_name_short === name)?.DictIntakeFormQuestion
        if (!!sumElement && !!sumElement.question_option_values && sumElement.question_type === "number") {
            let valuesToSum = []
            try {
                valuesToSum = JSON.parse(sumElement.question_option_values)
                
                // console.log("valuesToSum", valuesToSum)
                // const initialValue = 0;
                sum = valuesToSum.reduce((acc, curr) => {
                    return +acc + (+vals[curr]);
                }, 0)

            }
            catch {

            }
        } 
        return {...vals, [name]:sum}
    }

    // SAQ score = sum(q1...q9)*100/45
    const calculateSAQ = (vals, sumName, saqName) => {
        // const sumElement = props.questions.find(q => q.DictIntakeFormQuestion.display_name_short === sumName)
        // const saqElement = props.questions.find(q => q.DictIntakeFormQuestion.display_name_short === saqName)

        // console.log("calculateSAQ - vals, sumName, saqName", vals, sumName, saqName)
        // console.log("calculateSAQ - vals[sumName]", vals[sumName])
        const saq = Math.round((+vals[sumName]) * 100/45)
        return {...vals, [saqName]:saq}
    }



    const value_changed = (event, cell_index) => {
        // custom attribute of the element data-input-type shoudl contain type
        // let new_vals = values

        // console.log("value_changed: value, cell_index", event.target.value, cell_index)
        let new_data = values

        // console.log("elelemnt", event.target)
        const name = event.target.getAttribute('name')
        // console.log("elelemnt", event.target, "name", name)
        // different processing for numeric vs non-numeric values
        if (event.target.getAttribute('data-input-type') === 'number') {
            // allow only numeric characters
            const textVal = event.target.value.replace(/[^0-9]+/, '')
            new_data[name] = +(textVal)
            // new_vals = values.map((val, ix) => (ix !== cell_index ? val : +(textVal)))
        } else if (event.target.getAttribute('data-input-type') === 'text' || event.target.getAttribute('data-input-type') === 'textarea') {
            // new_vals = values.map((val, ix) => (ix !== cell_index ? val : event.target.value))
            new_data[name] = event.target.value
        } else if (event.target.getAttribute('data-input-type') === 'radio') {
            // new_vals = values.map((val, ix) => (ix !== cell_index ? val : event.target.value))
            new_data[name] = event.target.value
        } else if (event.target.getAttribute('data-input-type') === 'select') {
            new_data[name] = +(event.target.value)
        } 
        // console.log("NEW VALUES AFTER UPDATE", new_vals)


        
        
        // update values
        
        new_data = calculateSum(new_data, "sum_of_scores")
        new_data = calculateSAQ(new_data, "sum_of_scores", "saq_total_score")

        setValues(new_data)


        // console.log("Updating data:", new_data)
        props.onChange(new_data)

    }




    return (
        <>
            {
                props.questions[0].DictIntakeFormQuestion.group_header1 && parse(`${props.questions[0].DictIntakeFormQuestion.group_header1}`)
            }
            {
                props.questions[0].DictIntakeFormQuestion.group_header2 && parse(`${props.questions[0].DictIntakeFormQuestion.group_header2}`)
            }
            {
                props.questions[0].DictIntakeFormQuestion.group_header3 && parse(`${props.questions[0].DictIntakeFormQuestion.group_header3}`)
            }

            {!!props.questions
                .filter(q => !!q.DictIntakeFormQuestion.display_name_short || !!q.DictIntakeFormQuestion.display_name || !!q.DictIntakeFormQuestion.question_type)?.length
                &&
            <div className="border-less">
                <table className="table table-sm table-borderless">
                    <tbody>
                        {props.questions
                            .filter(q => !!q.DictIntakeFormQuestion.display_name_short || !!q.DictIntakeFormQuestion.display_name || !!q.DictIntakeFormQuestion.question_type)
                            .map((q, index, allQs) => 
                            <tr key={index}>
                                <td>

                                    {props.errors.length > 0 && props.errors.includes(q.DictIntakeFormQuestion.display_name_short) ? 
                                        <span className='text-danger'>{q.DictIntakeFormQuestion.display_name}</span> 
                                        :
                                        <span>{q.DictIntakeFormQuestion.display_name}</span>
                                    }
                                            {/* {q.display_name} */}

                                </td>
                                    <td>
                                        {q.DictIntakeFormQuestion.question_type === 'select' &&
                                        <Form.Select
                                            id={q.DictIntakeFormQuestion.display_name_short} 
                                            name={q.DictIntakeFormQuestion.display_name_short} 
                                            data-input-type={q.DictIntakeFormQuestion.question_type} 
                                            value={values[q.DictIntakeFormQuestion.display_name_short] !== undefined ? values[q.DictIntakeFormQuestion.display_name_short] : ''}
                                            onChange={(event) => value_changed(event, index)}
                                            // disabled={props.readOnly}
                                        >
                                            <option value=''></option>
                                            {JSON.parse(q.DictIntakeFormQuestion.question_option_values).map((v,vi) => 
                                                <option 
                                                    key={vi}
                                                    value={v}
                                                >
                                                    {v}
                                                </option>
                                            )}
                                        </Form.Select>

                                        }

                                        {q.DictIntakeFormQuestion.question_type === 'number' &&
                                            <input 
                                                type={q.DictIntakeFormQuestion.question_type} 
                                                id={q.DictIntakeFormQuestion.display_name_short} 
                                                name={q.DictIntakeFormQuestion.display_name_short} 
                                                data-input-type={q.DictIntakeFormQuestion.question_type} 
                                                value={values[q.DictIntakeFormQuestion.display_name_short] !== undefined ? values[q.DictIntakeFormQuestion.display_name_short] : 0}
                                                placeholder={0}
                                                readOnly={true}
                                            />
                                        }

                                        {/* {q.DictIntakeFormQuestion.question_type === 'saq' &&
                                            <input 
                                                type={q.DictIntakeFormQuestion.question_type} 
                                                id={q.DictIntakeFormQuestion.display_name_short} 
                                                name={q.DictIntakeFormQuestion.display_name_short} 
                                                data-input-type={q.DictIntakeFormQuestion.question_type} 
                                                value={values[q.DictIntakeFormQuestion.display_name_short] !== undefined ? values[q.DictIntakeFormQuestion.display_name_short] : 0}
                                                placeholder={0}
                                                readOnly={true}
                                            />
                                        } */}
                                        
                                    </td>

                                
                            </tr>

                        )}
                    </tbody>
                </table>
                
            </div>
            }
        </>
    )
}

export default SynkinesisQuestionGroup
